import React from "react";

import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import Button from "Common/Button";
import { Card } from "Common/Card/";
import { Col, Row } from "Common/Grid";

import { resetFilter } from "./Actions";

export const NoPlansCard = ({ onClick }) => (
  <Card>
    <div className="NoPlansCard__header_margin">
      <TitleSmall>No Plans Found</TitleSmall>
    </div>
    <div className="NoPlansCard__content_margin">We could not find any plans that match your criteria. Please adjust the filters.</div>
    <Row>
      <Col md={3}>
        <Button color="blue" size="medium" fullWidth onClick={onClick}>
          Reset Filters
        </Button>
      </Col>
    </Row>
  </Card>
);

function mapDispatchToProps(dispatch) {
  return {
    onClick: () => {
      AnalyticsTracking.trackEvent("cta_clicked", {
        location: "no_plans_card",
        action: "reset_dental_filter",
      });

      dispatch(resetFilter());
    },
  };
}

export default connect(null, mapDispatchToProps)(NoPlansCard);
